import React, {useState, useEffect} from "react";
import {Outlet, useLocation} from "react-router-dom";
import {
  Footer,
} from "./components";
import FadeIn from './components/FadeIn';
import './index.scss';
import Header from "./components/Header";
import {Helmet} from "react-helmet-async";

function App() {
    const [mode, setMode] = useState<string>('light');
    const location = useLocation();
    const hideFooter = location.pathname.startsWith("/blog");
    const handleModeChange = () => {
        if (mode === 'dark') {
            setMode('light');
        } else {
            setMode('dark');
        }
    }

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [location.pathname]);

    return (
        <>
            <Helmet>
                <title>Aggrey Lelei | Head Of Tech, Agentic AI Architect</title>
                <meta
                    name="description"
                    content="Portfolio, projects, blog posts and agentic engineering work by Aggrey Lelei."
                />
                {/* Open Graph base */}
                <meta property="og:site_name" content="Aggrey Lelei" />
                <meta property="og:type" content="website" />

                {/* Twitter base */}
                <meta name="twitter:card" content="summary_large_image" />

                {/* Optional but clean */}
                <meta name="robots" content="index, follow" />
            </Helmet>
            <div className={`main-container ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`}>
                {/*<Navigation parentToChild={{mode}} modeChange={handleModeChange}/>*/}
                <Header/>
                <FadeIn transitionDuration={700}>
                    {/*<Particle/>*/}
                    <Outlet/>
                </FadeIn>
                {!hideFooter && <Footer />}
            </div>
        </>
    );
}

export default App;